export default __webpack_public_path__ + "static/media/kitchen3-afterC-1024w.b20c7daa.png";